import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnChanges } from '@angular/core';
import { IListingSizeOption } from '@df/catalog-ui/listing/size/listing-size';
import { ListingSizeComponentDef } from '@df/catalog-ui/listing/size/listing-size.component.def';
import { GtmService } from '@df/module-gtm/gtm.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { NListing } from '../product-listing.interface';
@Component({
    selector: 'listing-size',
    templateUrl: './listing-size.html',
    standalone: true,
    imports: [NgClass, TranslationModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListingSizeComponent extends ListingSizeComponentDef implements OnChanges, NListing.ISize {
    private gtmService = inject(GtmService);
    /**
     * When size changes reset subscription
     */
    override ngOnChanges(changes) {
        if (changes['size']) {
            this.sendA4Event();
            this.sizeSubscription?.unsubscribe();
            this.sizeSubscription = this.size.subscribe(() => {
                this.sendA4Event();
                this.detectChanges();
            });
        }
    }
    private sendA4Event(): void {
        this.gtmService.sendEventGA4('plp_layout', { grid: this.size.selectedSize + '-col' });
    }
    get options() {
        return this.size.getOptions();
    }
    isSelected(option: NListing.ISizeOption | IListingSizeOption): boolean {
        return this.size.isSelected(option);
    }
    setState(size: number): void {
        this.size.setState(size);
    }
}
